import type { ComponentType } from 'react';

// Обгортка над RR v7 `lazy`: тримає named-export → { Component } мапінг в одному місці,
// щоб кожен domain-route оголошував ленивий чанк одним рядком без boilerplate.
export const lazyComponent =
  (importer: () => Promise<Record<string, ComponentType>>, name: string) => async () => ({
    Component: (await importer())[name],
  });
